import React from 'react';

/**
 * @return {null}
 */
export default function SeoBreadcrumbs() {
    const showCountryBreadcrumb = FINN?.travel?.destination?.country;
    const showCityBreadcrumb = FINN?.travel?.destination?.city;

    return FINN?.travel?.enableSeo && showCountryBreadcrumb ? (
        <>
            {showCountryBreadcrumb && (
                <li>
                    <span className="u-display-inline-block u-ma0 u-b1">
                        <a
                            href={`${FINN.travel.contextPath + FINN?.travel?.destination?.country.replace(/ /g, '+')}/`}
                            data-testid="country">
                            {FINN?.travel?.destination?.country}
                        </a>
                    </span>
                </li>
            )}
            {showCityBreadcrumb && (
                <li>
                    <span className="u-display-inline-block u-ma0 u-b1">
                        <span data-testid="city">{FINN?.travel?.destination?.city}</span>
                    </span>
                </li>
            )}
        </>
    ) : null;
}
